import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import EnergyProcessFlow from "./EnergyProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";
import {
  ENERGY_DOMAIN_INTRO,
  ENERGY_GROUPS,
  ENERGY_USE_CASES_SEO,
  ENERGY_DOMAIN_FAQS,
  ENERGY_ITEM_LIST_JSONLD,
  ENERGY_BREADCRUMB_JSONLD,
  ENERGY_WEBPAGE_JSONLD,
  ENERGY_FAQ_JSONLD,
} from "../../data/energyUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<EnergyProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = ENERGY_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function EnergyDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? ENERGY_GROUPS : ENERGY_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={ENERGY_DOMAIN_INTRO}
        domainSlug="energy-domain"
        useCaseCount={ENERGY_USE_CASES_SEO.length}
        groupCount={ENERGY_GROUPS.length}
        itemListJsonLd={ENERGY_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={ENERGY_BREADCRUMB_JSONLD}
        faqJsonLd={ENERGY_FAQ_JSONLD}
        webPageJsonLd={ENERGY_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{ENERGY_DOMAIN_INTRO.title}</h1>
          {ENERGY_DOMAIN_INTRO.content ? <p>{ENERGY_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={ENERGY_USE_CASES_SEO} groups={ENERGY_GROUPS} heading="Energy & Utilities Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>
      <DomainHiddenSeoContent
        domainTitle={ENERGY_DOMAIN_INTRO.title}
        domainFaqs={ENERGY_DOMAIN_FAQS}
        useCases={ENERGY_USE_CASES_SEO}
      />
    </div>
  );
}

